import { createI18n } from 'vue-i18n';
import configuration from '@/configurations';

function loadLocaleMessages () {
  const locales = require.context('../locales', false, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};

  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);

    if (matched && matched.length > 1) {
      const locale = matched[1];

      messages[locale] = locales(key);
    }
  });

  return messages;
}

export default createI18n({
  locale: configuration.app_i18n_locale,
  fallbackLocale: configuration.app_i18n_fallback_locale,
  messages: loadLocaleMessages(),
});
